/**
 * WordPress dependencies
 */
import {
	select as doSelect,
	dispatch as doDispatch,
} from '@safe-wordpress/data';
import { useEffect } from '@safe-wordpress/element';

/**
 * External dependencies
 */
import { store as NAB_DATA, usePageAttribute } from '@nab/data';
import type { JavaScriptEditorState } from '@nab/types';

const INIT: JavaScriptEditorState = {
	activeResolution: 'desktop',
	areControlsVisible: true,
	isPreviewInScope: false,
	isSaving: false,
};

export function useEditorState(): [
	JavaScriptEditorState,
	( state: Partial< JavaScriptEditorState > ) => void,
] {
	const [ state, setState ] = usePageAttribute(
		'javascript-editor/javascriptEditorState',
		INIT
	);

	useEffect(
		() => void ( INIT === state ? setState( INIT ) : null ),
		[ state, setState ]
	);

	return [ state, ( newState ) => setState( { ...state, ...newState } ) ];
}

// HACK. I had to implement it this way because there’s an async stuff in place to save experiment.
export function useMarkAsSavingFunction(): typeof markAsSaving {
	return markAsSaving;
}

function markAsSaving( isSaving: boolean ) {
	const state =
		doSelect( NAB_DATA ).getPageAttribute(
			'javascript-editor/javascriptEditorState'
		) || INIT;
	if ( ! state ) {
		return;
	}

	void doDispatch( NAB_DATA ).setPageAttribute(
		'javascript-editor/javascriptEditorState',
		{
			...state,
			isSaving,
		}
	);
}
